import topLevelData from 'sagas/firebase/io/topLevelData';

export default [topLevelData];
